import styled from "styled-components";
import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const TextDescWrapper = styled(Box)`
  border-radius: 12px;
  width: auto;
  margin-bottom: 32px;
  ${(props) => props.styles || ""}
`;

export const DescriptionText = styled(Text)`
  color: var(--Text-Primary-grey600, #121212);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  ${(props) => props.styles || ""}
`;

export const ImageBoxContainer = styled.div`
  border-radius: 8px;
  background: #eaf6ff;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  margin-right: 5px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
